import api from "./api";
import { useEffect, useState } from "react";
import { useUserSuperEmpresa } from "../Context/AuthContext";

export const useServiciosClinicos = () => {
    const { Token } = useUserSuperEmpresa();

     const getserviciosclinicos = async (params = {}) => {
    try {
      const { data } = await api.get("/all/servicios/clinicos", { 
        params,
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        }
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener ingresos";
    }
  };

   const postServicioClinico = async (params = {}) => {
    try {
      const { data } = await api.post("/crear/servicios/clinicos", params, {
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        },
      });
      return data.data;
    } catch (error) {
      throw error.response?.data?.message || "Error al crear ingreso";
    }
  };

   const eliminarServicioClinico = async (id) => {
    try {
      const { data } = await api.delete(`/eliminar/servicios/clinicos/${id}`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al eliminar el usuario";
    }
  };

   return { getserviciosclinicos,  postServicioClinico, eliminarServicioClinico };
}


export const useGetServiciosClinicos = () => {
  const { Token } = useUserSuperEmpresa();
  const {getserviciosclinicos } = useServiciosClinicos();
  const [servicios, setServicios] = useState([]);
  const [loadings, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchServiciosclinicos = async () => {
    setLoading(true);
    try {
      const data = await getserviciosclinicos();
      setServicios(data);
    } catch (err) {
      setError(err.response?.data?.message || "Error al obtener sucursales");
    } finally {
      setLoading(false);
    }
  };

  // Cargar al montar
  useEffect(() => {
    if (Token)fetchServiciosclinicos();
  }, [Token]);

  // ✅ Retorna la función refetch
  return { servicios, loadings, error, refetch:fetchServiciosclinicos };
};